import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 122 121.9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M110.3 65H54.1c-2.6 0-3.7 1.2-3.7 3.2 0 5.1 2.8 10 8.4 14.6s11.6 7 18.1 7 8.1-.7 12.8-2.1 8.6-3.2 11.6-5.3c2.8-1.9 4.9-2.8 6.5-2.8s4.2 1.2 6 3.7c2.1 2.6 3 5.1 3 7.9 0 5.8-3.5 11.1-10.7 16.5-12.5 9.5-27.2 14.2-43.7 14.2s-30.7-4.9-42-14.6c-5.6-4.9-10-10.4-13.5-17.2C2.3 81.1 0 71.8 0 61.8s4-25.3 12.1-36c7-9.3 15.8-16 26.7-20.7C46.9 1.6 55.7 0 65 0c15.1 0 27.9 4.2 38.6 12.8 5.3 4.2 9.5 9.3 12.8 15.3 3.7 6.7 5.6 13.2 5.6 19.5s-1.2 9.3-3.2 12.8c-2.3 3-5.1 4.7-8.4 4.7ZM57.4 42.7h12.1c5.1 0 7.7-2.3 7.7-7s-1.2-7.9-3.7-10.4c-2.6-2.8-5.6-3.9-9.8-3.9s-7.9 1.9-10.5 5.3c-2.3 3.2-3.5 6.5-3.5 10s.5 3.9 1.6 5.1c1.2.5 3 .9 6 .9Z",
      style: {"fill":"#f60"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "DS-logo"}) } }